
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2430',
  depVersions: {
  "customer-portal-app": "static-1.2430",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.471",
  "data-fetching-client": "static-1.9704",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25502",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5629",
  "hs-test-utils": "static-1.8054",
  "hub-http": "static-1.6261",
  "hub-http-shared-msw-handlers": "static-1.10061",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18350",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11511",
  "I18n": "static-7.1632",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6502",
  "payment-link-components": "static-1.23622",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7080",
  "quartz-core": "static-1.6299",
  "quartz-i18n": "static-1.755",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10247",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5373",
  "rich-text-lib": "static-1.19900",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18054",
  "ui-components-test-utils": "static-1.5648",
  "UIComponents": "static-3.8457",
  "foundations-assets": "static-1.4906",
  "foundations-components": "static-1.8008",
  "foundations-theming": "static-1.4457",
  "foundations-theming-specialty": "static-1.2173",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.968",
  "quartz-config": "static-1.858",
  "quartz-routing": "static-1.510",
  "quick-fetch": "static-1.3946",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16712",
  "rpc-client-utils": "static-1.4690",
  "sanitize-text": "static-1.8181",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4800",
  "ui-addon-react-router-dom": "static-1.9580",
  "usage-tracker": "static-1.7387",
  "usage-tracker-anonymous": "static-1.5804",
  "usage-tracker-core": "static-1.7237",
  "video-components-external": "static-1.11431",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3428",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3357",
  "quartz-webpack": "static-1.3304",
  "bend-plugin-quartz-routing": "static-1.158",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7713",
  "frontend-preferences-client": "static-1.7966",
  "laboratory-lib": "static-3.7195",
  "onboarding-scopes": "static-1.6499",
  "seat-types-lib": "static-1.110",
  "ui-addon-opt": "static-4.8401",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3165",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.110",
  "ts-schema": "static-1.4109",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7811",
  "cssUtils": "static-1.799",
  "customer-data-ui-utilities": "static-1.9864",
  "HubStyle": "static-2.11818",
  "knowledge-content-types": "static-1.8504",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.488",
  "ui-addon-emoji-picker": "static-1.9926",
  "ui-addon-i18n": "static-1.11188",
  "ui-business-units-lib": "static-1.9096",
  "ui-shepherd-react": "static-3.10229",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4365",
  "commerce-tours-lib": "static-1.6177",
  "customer-data-properties": "static-1.51710",
  "getting-started-shared-tasks": "static-1.18556",
  "growth-onboarding-reliability": "static-1.5119",
  "onboarding-tours": "static-1.16678",
  "reference-resolvers-lite": "static-1.8135",
  "sales-checkout-service-client": "static-1.3680",
  "ui-addon-iframeable": "static-1.9099",
  "user-context": "static-1.5144",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4680",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.755",
  "quartz-head": "static-1.745",
  "quartz-test": "static-1.755",
  "quartz-tracking": "static-1.459",
  "ui-fonts": "static-1.773",
  "usage-tracker-container": "static-1.7377",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9461",
  "data-token-picker": "static-1.16474",
  "FileManagerLib": "static-1.39373",
  "property-translator": "static-1.5436",
  "atom": "static-1.5113",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5988",
  "salesImages": "static-1.526",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5491",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1161",
  "bend-plugin-foundations-components": "static-1.4277",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.30",
  "trellis-assets": "static-1.2046",
  "bend-plugin-foundations-theming": "static-1.2940",
  "foundations-theming-base": "static-1.3442",
  "stylex": "static-1.33",
  "interframe": "static-3.4797",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5801",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.100",
  "chirp-fetch": "static-1.1926",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4515",
  "react-flip-move": "static-1.70",
  "apollo-link-hub-http": "static-2.4690",
  "content-media-composition-data-lib": "static-1.12474",
  "content-media-compositions": "static-2.16481",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4192",
  "magpie-lib": "static-1.5575",
  "magpie-types": "static-1.5035",
  "media-bridge-lib": "static-1.18994",
  "video-data-lib": "static-1.35089",
  "bender-build-tools": "static-1.3227",
  "inbound-db-properties-service-client": "static-1.3875",
  "superstore": "static-1.4799",
  "feedback-loader": "static-1.29370",
  "ai-components-ui-library": "static-1.9072",
  "ui-addon-video-player": "static-1.8742",
  "ui-coaching-tips": "static-1.28679",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4652",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2537",
  "navigation-messaging": "static-1.7471",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8210",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9717",
  "crm-message-bus": "static-1.43081",
  "growth-data-modal": "static-1.5488",
  "hubspot-apollo-client": "static-1.4916",
  "onboarding-tours-client": "static-1.4892",
  "calling-global-api": "static-1.64658",
  "calling-internal-common": "static-1.31341",
  "calling-lifecycle-internal": "static-1.66040",
  "calling-lifecycle-messages": "static-1.58334",
  "conditional-properties-service-client": "static-1.3827",
  "crm-links": "static-1.6341",
  "customer-data-objects-ui-components": "static-1.13069",
  "customer-data-properties-shared-msw-handlers": "static-1.9388",
  "customer-data-property-utils": "static-1.8129",
  "external-options-client-types": "static-1.4189",
  "file-manager-components": "static-1.23733",
  "framework-data-schema-resolvers": "static-1.6925",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.195",
  "inbound-db-meta-service-client": "static-1.3615",
  "inbounddb-objects-service-types": "static-1.4252",
  "meetings-icalendar-utils-lib": "static-1.670",
  "multi-currency-client-types": "static-1.3721",
  "object-builder-ui-client": "static-1.48886",
  "pipeline-validation-client-types": "static-1.3994",
  "property-value-citations": "static-1.2324",
  "pulse": "static-1.619",
  "smart-property-lib": "static-1.7299",
  "tiered-pricing": "static-1.1307",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11028",
  "growth-onboarding-confetti": "static-1.3105",
  "growth-onboarding-next-action-utils": "static-1.2044",
  "navigation-components": "static-1.18144",
  "onboarding-tours-utils": "static-1.744",
  "ui-shepherd-tracker": "static-1.7610",
  "ui-universal-auth": "static-1.9023",
  "batch-promise": "static-1.1580",
  "getting-started-shared-tasks-store": "static-1.17674",
  "hubspotter-http-shared-msw-handlers": "static-1.10059",
  "usage-tracker-session-replay": "static-1.5073",
  "audio-components": "static-1.5974",
  "FileManagerCore": "static-1.39232",
  "FileManagerImages": "static-1.36884",
  "video-components": "static-1.13433",
  "foundations-components-legacy": "static-1.1033",
  "purchase-motions-api": "static-1.5991",
  "signup-constants": "static-1.18915",
  "signup-ui-url-generator": "static-2.8093",
  "usage-tracker-public": "static-1.7198",
  "reactive-lib": "static-1.762",
  "simple-logging-lib": "static-1.3089",
  "chatspot-core": "static-1.21461",
  "ContentUtils": "static-1.68489",
  "copilot-toolkit": "static-1.11237",
  "growth-onboarding-feedback-components": "static-1.6618",
  "commerce-permissions": "static-1.811",
  "customer-data-tracking": "static-1.6928",
  "products-iframe-lib": "static-1.8054",
  "products-ui-components-shared-msw-handlers": "static-1.10443",
  "restore-request-side-panel-lib": "static-1.1015",
  "onboarding-data-sync-lib": "static-1.2018",
  "hubspot-apollo-cache": "static-1.375",
  "calling-error-reporting": "static-1.31348",
  "shared-worker-versioning": "static-1.11073",
  "calling-usage-tracker": "static-1.6579",
  "self-service-api": "static-1.10285",
  "voice-sms-access-library": "static-1.1177",
  "conversations-skeleton-state": "static-1.7287",
  "location-customization-utils-lib": "static-1.9386",
  "crm-pipelines-api-client-types": "static-1.4169",
  "fdsr-migration-layer": "static-1.44",
  "framework-builder-read-service-client": "static-1.4034",
  "framework-data-schema-quick-fetch": "static-1.6830",
  "persist-promise": "static-1.3737",
  "bend-plugin-pulse": "static-1.122",
  "event-emitter": "static-1.985",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.255",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10144",
  "fsm": "static-1.3769",
  "policy-lib": "static-1.6815",
  "react-tinymce": "static-1.55362",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10207",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54488",
  "tinymce-plugins": "static-1.57602",
  "tinymce-themes": "static-1.56458",
  "growth-onboarding-next-action-components": "static-1.2072",
  "user-context-client": "static-1.4651",
  "nest": "static-1.268",
  "unified-auth-core-lib": "static-1.819",
  "amplitude-session-replay-browser": "static-1.61",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4576",
  "video-embed": "static-1.35923",
  "content-icons-ui": "static-1.2234",
  "social-insights-client-types": "static-1.22224",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4850",
  "integrations-lib": "static-1.16303",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.778",
  "sales-views-client-types": "static-1.4297",
  "InboxConnectUtils": "static-4.14930",
  "meetings-connect-utils-lib": "static-1.7642",
  "calling-orchestration-schema": "static-1.35954",
  "crm-record-cards-service-types": "static-1.3618",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4552",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3080",
  "tinymce-data": "static-1.40573",
  "ui-addon-sales-email": "static-1.5250",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12517",
  "layout-dnd-utils": "static-1.11492",
  "react-codemirror": "static-1.10666",
  "ui-brand-identity-lib": "static-1.15447",
  "NamespacedHubStyle": "static-2.9088",
  "outpost": "static-1.4216",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13718",
  "integrations-tracking-lib": "static-1.5641",
  "native-integrations-shared-strings": "static-1.7820",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10403",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.537",
  "breeze-engine-core": "static-1.56",
  "ably": "static-2.2",
  "highlight.js": "static-1.79",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68564",
  "layout-data-lib": "static-1.9817",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3053",
  "google-sheets-integration-lib": "static-1.363",
  "microsoft-drive-integration-lib": "static-1.490",
  "slack-ui-library": "static-1.10430",
  "advanced-menus-core": "static-1.15188",
  "advanced-menus-lib": "static-1.12126",
  "ExportDialog": "static-6.10424",
  "ui-memberships-settings-lib": "static-1.34164",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15187",
  "simple-menus-lib": "static-1.16704"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2430",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.471",
  "data-fetching-client": "/data-fetching-client/static-1.9704",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25502",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5629",
  "hs-test-utils": "/hs-test-utils/static-1.8054",
  "hub-http": "/hub-http/static-1.6261",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10061",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18350",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11511",
  "I18n": "/I18n/static-7.1632",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6502",
  "payment-link-components": "/payment-link-components/static-1.23622",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7080",
  "quartz-core": "/quartz-core/static-1.6299",
  "quartz-i18n": "/quartz-i18n/static-1.755",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10247",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5373",
  "rich-text-lib": "/rich-text-lib/static-1.19900",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18054",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5648",
  "UIComponents": "/UIComponents/static-3.8457",
  "foundations-assets": "/foundations-assets/static-1.4906",
  "foundations-components": "/foundations-components/static-1.8008",
  "foundations-theming": "/foundations-theming/static-1.4457",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2173",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.968",
  "quartz-config": "/quartz-config/static-1.858",
  "quartz-routing": "/quartz-routing/static-1.510",
  "quick-fetch": "/quick-fetch/static-1.3946",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16712",
  "rpc-client-utils": "/rpc-client-utils/static-1.4690",
  "sanitize-text": "/sanitize-text/static-1.8181",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4800",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9580",
  "usage-tracker": "/usage-tracker/static-1.7387",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5804",
  "usage-tracker-core": "/usage-tracker-core/static-1.7237",
  "video-components-external": "/video-components-external/static-1.11431",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3428",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3357",
  "quartz-webpack": "/quartz-webpack/static-1.3304",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.158",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7713",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7966",
  "laboratory-lib": "/laboratory-lib/static-3.7195",
  "onboarding-scopes": "/onboarding-scopes/static-1.6499",
  "seat-types-lib": "/seat-types-lib/static-1.110",
  "ui-addon-opt": "/ui-addon-opt/static-4.8401",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3165",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.110",
  "ts-schema": "/ts-schema/static-1.4109",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7811",
  "cssUtils": "/cssUtils/static-1.799",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9864",
  "HubStyle": "/HubStyle/static-2.11818",
  "knowledge-content-types": "/knowledge-content-types/static-1.8504",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9926",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11188",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9096",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10229",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4365",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6177",
  "customer-data-properties": "/customer-data-properties/static-1.51710",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18556",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5119",
  "onboarding-tours": "/onboarding-tours/static-1.16678",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8135",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3680",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9099",
  "user-context": "/user-context/static-1.5144",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4680",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.755",
  "quartz-head": "/quartz-head/static-1.745",
  "quartz-test": "/quartz-test/static-1.755",
  "quartz-tracking": "/quartz-tracking/static-1.459",
  "ui-fonts": "/ui-fonts/static-1.773",
  "usage-tracker-container": "/usage-tracker-container/static-1.7377",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9461",
  "data-token-picker": "/data-token-picker/static-1.16474",
  "FileManagerLib": "/FileManagerLib/static-1.39373",
  "property-translator": "/property-translator/static-1.5436",
  "atom": "/atom/static-1.5113",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5988",
  "salesImages": "/salesImages/static-1.526",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5491",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1161",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4277",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.30",
  "trellis-assets": "/trellis-assets/static-1.2046",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2940",
  "foundations-theming-base": "/foundations-theming-base/static-1.3442",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4797",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5801",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.100",
  "chirp-fetch": "/chirp-fetch/static-1.1926",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4515",
  "react-flip-move": "/react-flip-move/static-1.70",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4690",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12474",
  "content-media-compositions": "/content-media-compositions/static-2.16481",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4192",
  "magpie-lib": "/magpie-lib/static-1.5575",
  "magpie-types": "/magpie-types/static-1.5035",
  "media-bridge-lib": "/media-bridge-lib/static-1.18994",
  "video-data-lib": "/video-data-lib/static-1.35089",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3875",
  "superstore": "/superstore/static-1.4799",
  "feedback-loader": "/feedback-loader/static-1.29370",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9072",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8742",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28679",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4652",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2537",
  "navigation-messaging": "/navigation-messaging/static-1.7471",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8210",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9717",
  "crm-message-bus": "/crm-message-bus/static-1.43081",
  "growth-data-modal": "/growth-data-modal/static-1.5488",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4916",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4892",
  "calling-global-api": "/calling-global-api/static-1.64658",
  "calling-internal-common": "/calling-internal-common/static-1.31341",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66040",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58334",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3827",
  "crm-links": "/crm-links/static-1.6341",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13069",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9388",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8129",
  "external-options-client-types": "/external-options-client-types/static-1.4189",
  "file-manager-components": "/file-manager-components/static-1.23733",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6925",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.195",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3615",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4252",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.670",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3721",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48886",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3994",
  "property-value-citations": "/property-value-citations/static-1.2324",
  "pulse": "/pulse/static-1.619",
  "smart-property-lib": "/smart-property-lib/static-1.7299",
  "tiered-pricing": "/tiered-pricing/static-1.1307",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11028",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3105",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2044",
  "navigation-components": "/navigation-components/static-1.18144",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.744",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7610",
  "ui-universal-auth": "/ui-universal-auth/static-1.9023",
  "batch-promise": "/batch-promise/static-1.1580",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17674",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10059",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5073",
  "audio-components": "/audio-components/static-1.5974",
  "FileManagerCore": "/FileManagerCore/static-1.39232",
  "FileManagerImages": "/FileManagerImages/static-1.36884",
  "video-components": "/video-components/static-1.13433",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1033",
  "purchase-motions-api": "/purchase-motions-api/static-1.5991",
  "signup-constants": "/signup-constants/static-1.18915",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8093",
  "usage-tracker-public": "/usage-tracker-public/static-1.7198",
  "reactive-lib": "/reactive-lib/static-1.762",
  "simple-logging-lib": "/simple-logging-lib/static-1.3089",
  "chatspot-core": "/chatspot-core/static-1.21461",
  "ContentUtils": "/ContentUtils/static-1.68489",
  "copilot-toolkit": "/copilot-toolkit/static-1.11237",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6618",
  "commerce-permissions": "/commerce-permissions/static-1.811",
  "customer-data-tracking": "/customer-data-tracking/static-1.6928",
  "products-iframe-lib": "/products-iframe-lib/static-1.8054",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10443",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1015",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2018",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.375",
  "calling-error-reporting": "/calling-error-reporting/static-1.31348",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11073",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6579",
  "self-service-api": "/self-service-api/static-1.10285",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1177",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7287",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9386",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4169",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.44",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4034",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6830",
  "persist-promise": "/persist-promise/static-1.3737",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.122",
  "event-emitter": "/event-emitter/static-1.985",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.255",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10144",
  "fsm": "/fsm/static-1.3769",
  "policy-lib": "/policy-lib/static-1.6815",
  "react-tinymce": "/react-tinymce/static-1.55362",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10207",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57602",
  "tinymce-themes": "/tinymce-themes/static-1.56458",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2072",
  "user-context-client": "/user-context-client/static-1.4651",
  "nest": "/nest/static-1.268",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.819",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.61",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4576",
  "video-embed": "/video-embed/static-1.35923",
  "content-icons-ui": "/content-icons-ui/static-1.2234",
  "social-insights-client-types": "/social-insights-client-types/static-1.22224",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4850",
  "integrations-lib": "/integrations-lib/static-1.16303",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.778",
  "sales-views-client-types": "/sales-views-client-types/static-1.4297",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14930",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7642",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35954",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3618",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4552",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3080",
  "tinymce-data": "/tinymce-data/static-1.40573",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5250",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12517",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11492",
  "react-codemirror": "/react-codemirror/static-1.10666",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15447",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9088",
  "outpost": "/outpost/static-1.4216",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13718",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5641",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7820",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10403",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.537",
  "breeze-engine-core": "/breeze-engine-core/static-1.56",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.79",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68564",
  "layout-data-lib": "/layout-data-lib/static-1.9817",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3053",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.363",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.490",
  "slack-ui-library": "/slack-ui-library/static-1.10430",
  "advanced-menus-core": "/advanced-menus-core/static-1.15188",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12126",
  "ExportDialog": "/ExportDialog/static-6.10424",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34164",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15187",
  "simple-menus-lib": "/simple-menus-lib/static-1.16704"
}
};
